import Hr from "./Hr";

export default Hr;
